import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploaderComponent } from './file-uploader.component';
import { FormsModule } from '@angular/forms';
import { BrnSelectModule } from '@spartan-ng/ui-select-brain';
import { HlmSelectModule } from '@spartan-ng/ui-select-helm';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
  declarations: [
    FileUploaderComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    BrnSelectModule,
    HlmSelectModule,
    SharedModule
  ],
  providers: [],
  exports: [
    FileUploaderComponent
  ]
})
export class FileUploaderModule { }